
const ATTR_TYPES = {
    STRING: 'string',
    INTEGER: 'integer',
    FLOAT: 'float'
};

const getAttributeById = (dataDefinition, id) => {
    let attr = null;
    if (dataDefinition && dataDefinition.attributes) {
        attr = dataDefinition.attributes.reduce((previous, current) => {
            return (current.id === id) ? current : previous;
        }, null);
    }
    if (!attr) {
        console.warn(`attribute with ID=${id} doesn't exist`);
    }
    return attr;
}

const getKeyAttribute = (dataDefinition) => {
    let key = null;
    if (dataDefinition && dataDefinition.attributes) {
        key = dataDefinition.attributes.reduce((previous, current) => {
            return (current.key) ? current : previous;
        }, null);
    }
    if (!key) {
        console.warn(`key attribute doesn't exist`);
    }
    return key;
}

export {
    ATTR_TYPES,
    getAttributeById,
    getKeyAttribute
};
